export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activation d'un chèque électronique"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte de dépôt"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Série"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Code d'activation"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérifier"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activer"])}
}